import React, { useContext, useEffect, useState } from "react";
import { Album } from "../../types/Album";
import { AuthenticationContext } from "../authentication/AuthenticationContext";
import { FileResponse } from "../../types/FileResponse";
import { getAlbumThumbnail } from "../apis/music-api";
import { Box, Link, useMediaQuery } from "@mui/material";
import { BeatLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import blankRecord from '../../assets/blank-record.png';
import callApi from "../call-api/call-api";

type AlbumProps = {
    letter: string,
    artistName: string,
    album: Album,
    onClick?: () => void,
}

const AlbumLink = (props: AlbumProps) => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ thumbnail, setThumbnail ] = useState<FileResponse>();
    const [ exists, setExists ] = useState(false);
    const [ loading, setLoading ] = useState(true);
    const navigate = useNavigate();
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const maxChars = isSmall ? 6 : 10;
    
    useEffect(() => {
        setExists(props.album.title !== undefined);
        if (props.album.title !== undefined && props.album.year > 0) {
            callApi<FileResponse>(getAlbumThumbnail(getAccessToken(), props.artistName, `${props.album.year} - ${props.album.title}`), setThumbnail, setLoading);            
        }

        //props.onClick?.();
    }, [props.artistName, props.album.year, props.album.title, getAccessToken]);

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        if (props.album.title === undefined) {
            return;
        }

        props.onClick?.();
        navigate(`/letters/${props.letter}/artists/${(props.artistName)}/albums/${(`${props.album.year} - ${props.album.title}`)}`);
    }
    
    return (
        <Box>
            <Box
                sx={{
                    width: isSmall ? '80px' : '120px',
                    height: isSmall ? '80px' : '120px',
                    textAlign: 'center', padding: '10px'
                }}
            >
                {exists && <BeatLoader loading={loading} size={24} aria-label="Loading Spinner" data-testid="loader" />}
                {!exists && <img style={{ display: exists ? "none" : "block"}} width={isSmall ? '80px' : '120px'} height={isSmall ? '80px' : '120px'} src={blankRecord} alt="cover" />}
                <Link onClick={handleClick} href="#" style={{ display: exists ? "block" : "none"}}>
                    <img style={{ display: !loading && exists ? "block" : "none"}} alt={props.album.title} width={isSmall ? '80px' : '120px'} height={isSmall ? '80px' : '120px'} src={`data:image/jpeg;base64,${thumbnail?.fileContents}`} />
                </Link>
            </Box>
            <Box sx={{ width: isSmall ? '80px' : '120px', textAlign: 'center', margin: '20px 10px 10px 10px' }}>
                <div><b>{props.album.year}</b></div>
                <div>
                    <Link onClick={handleClick} href="#" style={{ color: 'inherit' }}>
                        {props.album.title?.length > maxChars ? `${props.album.title.substring(0, maxChars)}...` : props.album.title}
                    </Link>
                </div>
            </Box>
        </Box>
    );
}

export default AlbumLink;